import React from 'react';
import { SiteContent } from '../data/content';

interface FullExperienceProps {
  content: SiteContent['fullExperience'];
}

export const FullExperience: React.FC<FullExperienceProps> = ({ content }) => {
  return (
    <section className="full-exp-section" id="experience" aria-labelledby="exp-title">
      <div className="container">
        <div className="section-head section-head--split">
          <div>
            <p className="eyebrow">{content.eyebrow}</p>
            <h2 id="exp-title" className="section-title">
              {content.title}
            </h2>
          </div>
          <p className="date-disclaimer">[{content.dateDisclaimer}]</p>
        </div>

        <div className="experience-editorial-list">
          {content.items.map((item) => (
            <article key={item.id} className="experience-editorial-row">
              <div className="experience-marker-col">
                <span className="experience-marker">{item.marker}</span>
              </div>
              <div className="experience-info-col">
                <h3 className="experience-company">{item.company}</h3>
                <p className="experience-role">{item.role}</p>
                <p className="experience-summary">{item.summary}</p>
                {item.bullets && item.bullets.length > 0 && (
                  <ul className="experience-bullets">
                    {item.bullets.map((bullet, idx) => (
                      <li key={idx}>{bullet}</li>
                    ))}
                  </ul>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
